/**
 * @generated SignedSource<<368ae91a5e42d60eb5cff097289a19ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MyBuildsQuery$variables = {};
export type MyBuildsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"MyBuilds_viewer">;
  } | null;
};
export type MyBuildsQuery = {
  response: MyBuildsQuery$data;
  variables: MyBuildsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MyBuilds_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MyBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdc1d2692ca7025c81c61de2713c3de4",
    "id": null,
    "metadata": {},
    "name": "MyBuildsQuery",
    "operationKind": "query",
    "text": "query MyBuildsQuery {\n  viewer {\n    ...MyBuilds_viewer\n    id\n  }\n}\n\nfragment MyBuilds_viewer on Viewer {\n  user {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6927dfa89450d046e262aa4b0b45ef7";

export default node;
